<template>
  <div class="role-list">
    <vm-table
        ref="vmTable"
        height="64vh"
        :filter.sync="filter"
        module="basic"
        url="flowSheetConfigs">
      <el-button slot="toolbar" type="primary" size="mini" @click="$refs.onePieceFlowEdit.open()">新增</el-button>
      <template slot="adSearch">
        <div class="vm-search">
          <vm-search label="流水单名称">
            <el-input v-model.trim="filter.flowSheetName" placeholder="请输入流水单名称" clearable/>
          </vm-search>
          <vm-search label="模块名称">
            <el-input v-model.trim="filter.flowSheetTemplateName" placeholder="请输入模块名称" clearable/>
          </vm-search>
          <vm-search label="物料名称">
            <el-input v-model.trim="filter.materialName" placeholder="请输入物料名称" clearable/>
          </vm-search>
          <vm-search label="字段名称">
            <el-input v-model.trim="filter.fieldName" placeholder="请输入字段名称" clearable/>
          </vm-search>
        </div>
      </template>
      <el-table-column prop="flowSheetName" label="流水单名称">
        <template slot-scope="scope">
          <span style="color: #2d8cf0; cursor: pointer" @click="$refs.onePieceFlowEdit.open(scope.row, true)">{{scope.row.flowSheetName}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="flowSheetTemplateName" label="流水单模块名称"/>
      <el-table-column width="120" label="操作" align="center">
        <template slot-scope="scope">
          <el-button type="primary" @click="$refs.onePieceFlowEdit.open(scope.row)">编辑</el-button>
          <el-button type="danger" @click="deleteHandle(scope.row.pkid)">删除</el-button>
        </template>
      </el-table-column>
    </vm-table>
    <one-piece-flow-edit ref="onePieceFlowEdit" @save-success="getList"/>
  </div>
</template>
<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";
  import OnePieceFlowEdit from "./OnePieceFlowEdit.vue";
  export default {
    components: { VmTable, OnePieceFlowEdit, VmSearch },
    data() {
      return {
        filter: {
          flowSheetName: "",
          flowSheetTemplateName: "",
          materialName: "",
          fieldName: "",
        },
      };
    },

    mounted() {
      this.getList();
    },

    methods: {
      getList() {
        this.$refs.vmTable.getList();
      },

      // 删除
      deleteHandle(pkid) {
        this.$confirm("确定删除吗?", "提示", { type: "warning" }).then(() => {
          this.$http.delete("basic", "flowSheetConfigs", pkid).then(() => {
            this.getList();
            this.$message.success("删除成功");
          });
        });
      },
    },
  };
</script>
